import EventManager from "../../EventManager";

export interface ExpandableManagerEventData {
	type: "expand" | "collapse",
	area: string[]
}
export interface ExpandableManagerEventMap {
	"expand": ExpandableManagerEventData;
	"collapse": ExpandableManagerEventData;
}

export default class ExpandableManager {
	private static instance: ExpandableManager;

	private readonly eventManager = new EventManager<ExpandableManagerEventMap>();
	public readonly addEventListener = this.eventManager.addEventListener;
	public readonly removeEventListener = this.eventManager.removeEventListener;

	private constructor() {}

	static getInstance(): ExpandableManager {
		if (ExpandableManager.instance === undefined) {
			ExpandableManager.instance = new ExpandableManager();
		}
		return ExpandableManager.instance;
	}

	public do(actionName: "expand" | "collapse", area: string[]) {
		this.eventManager.notifyEventListeners(actionName, {type: actionName, area});
	}

	// TODO @Michael: Make this class into a component so we can automatically do a destroy.
	public destroy() {
		this.eventManager.destroy();
	}
}
